package app.nestbridge.feature.invitations.presentation

import androidx.compose.runtime.Composable
import app.nestbridge.feature.common.screen.DocumentViewerScreen
import app.nestbridge.feature.invitations.screen.InvitationConfirmationEvent
import app.nestbridge.feature.invitations.screen.InvitationConfirmationScreen
import app.nestbridge.feature.invitations.screen.InvitationConfirmationState
import app.nestbridge.feature.invitations.screen.InvitationResult
import com.slack.circuit.codegen.annotations.CircuitInject
import com.slack.circuit.runtime.Navigator
import com.slack.circuit.runtime.presenter.Presenter
import me.tatarka.inject.annotations.Assisted
import me.tatarka.inject.annotations.Inject
import software.amazon.lastmile.kotlin.inject.anvil.AppScope

@CircuitInject(
    screen = InvitationConfirmationScreen::class,
    scope = AppScope::class,
)
@Inject
class InvitationConfirmationPresenter(
    @Assisted private val navigator: Navigator,
    @Assisted private val screen: InvitationConfirmationScreen,
) : Presenter<InvitationConfirmationState> {

    @Composable
    override fun present(): InvitationConfirmationState {
        val sink: (InvitationConfirmationEvent) -> Unit = { event ->
            when (event) {
                InvitationConfirmationEvent.Confirm -> {
                    navigator.pop(
                        InvitationResult(
                            invitationId = screen.invitationId,
                            decision = when (screen.mode) {
                                InvitationConfirmationScreen.Mode.Accept -> InvitationResult.Decision.Accepted
                                InvitationConfirmationScreen.Mode.Decline -> InvitationResult.Decision.Declined
                            },
                        ),
                    )
                }

                InvitationConfirmationEvent.DecideLater -> navigator.pop(
                    InvitationResult(
                        invitationId = screen.invitationId,
                        decision = InvitationResult.Decision.Cancelled,
                    ),
                )

                InvitationConfirmationEvent.ShowTerms -> {
                    navigator.goTo(DocumentViewerScreen(DocumentViewerScreen.DocumentKind.Terms))
                }

                InvitationConfirmationEvent.ShowPrivacy -> {
                    navigator.goTo(DocumentViewerScreen(DocumentViewerScreen.DocumentKind.Privacy))
                }
            }
        }

        return InvitationConfirmationState(
            mode = screen.mode,
            eventSink = sink,
        )
    }
}
